<!-- 首页 -->

<template>
<div class="home">
    <div class="bg_box">
        <div class="rowBox">
            <h1 class="t_c t_c_xbt">写论文如此简单</h1>
            <p class="t_c f_c7 Mtop" style="font-size: 20px;">专业的写论文平台</p>
            <p class="t_c f_c7 f_sz" style="font-size: 20px;">一秒生成数个专业的推荐思路及内容供你选择，写作变得如此简单</p>
            <div class="t_c top50">
                <button class="start" @click="gowriting">开始创作</button>
                <button class="look" @click="gosample">查看示例</button>
            </div>
            <div class="banner_box1"><img src="../../../static/images/index_banner.png" alt="" srcset="" /></div>
            <div class="bi"></div>
            <div class="gan"></div>
        </div>
    </div>
    <h2 class="t_c my_top">丰富的智能写作方案</h2>
    <div class="mytabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane v-for="item in tabsList" :key="item.name" :label="item.label" :name="item.name"></el-tab-pane>
        </el-tabs>
        <div class="databox">
            <div class="databox-lists"><img :src="dblistImg" alt="" /></div>
        </div>
    </div>

    <div class="titlelist">
        <div class="imglist">
            <img src="../../../static/images/index_bk2_icon.png" alt="">
        </div>
        <div class="textlist">
            <h2>
                数十亿学术文献基础，打造
                <br />
                最强学术大脑
            </h2>
            <p class="f_c7 f_sz ptop">
                在学习文献方面机器是真正的最强大脑。我们的AI写作机器人经过数十亿学术文献期刊的学习，具备最专业最全面的知识，基于如此强大的学术资源，写出来的论文如何能不专业！
            </p>
        </div>
    </div>
    <div class="titlelist">
        <div class="textlist textlisttwo">
            <h2>自主创作，快速高效，创作 出的内容经得起考验</h2>
            <p class="f_c7 f_sz ptop">
                先进的AI技术，机器人自主学习专业语料，只需一秒，生成多个推荐提纲、写作思路，文本智能生成、句子补写通通不在话下，无论是查重还是纠错，写出来的内容都经得起考验。
            </p>
        </div>
        <div class="Rimglist">
            <img src="../../../static/images/index_bk3_icon.png" alt="">
        </div>
    </div>
    <div class="titlelist">
        <div class="imglist">
            <img src="../../../static/images/index_bk4_icon.png" alt="">
        </div>
        <div class="textlist">
            <h2>能力丰富，简单易用，满足您写论文当中的所有需求</h2>
            <p class="f_c7 f_sz ptop">写论文的同时一边看资料、查重、改重，论文摘要、关键词、致谢一键生成，智能纠正论文中的错别字，只有你想不到，没有我们做不到！</p>
        </div>
    </div>

</div>
</template>

<script>
export default {
    data() {
        return {
            activeName: 'ouline',
            tabsList: [{
                    label: '提纲推荐',
                    name: 'ouline'
                },
                {
                    label: '写作思路',
                    name: 'writing'
                },
                {
                    label: '资料库',
                    name: 'datalist'
                },
                {
                    label: '智能生成',
                    name: 'aiWriting'
                },
                {
                    label: '实时查重',
                    name: 'timeScareh'
                },
                {
                    label: '智能纠错',
                    name: 'ailook'
                }
            ],
            dblistImg: '../../../static/images/index_bk_icon1.gif'
        }
    },
    methods: {
        // tab切换
        handleClick(tab, event) {
            switch (tab.name) {
                case 'ouline':
                    this.dblistImg = '../../../static/images/index_bk_icon1.gif'
                    break
                case 'writing':
                    this.dblistImg = '../../../static/images/index_bk_icon2.gif'
                    break
                case 'datalist':
                    this.dblistImg = '../../../static/images/index_bk_icon3.gif'
                    break
                case 'aiWriting':
                    this.dblistImg = '../../../static/images/index_bk_icon4.gif'
                    break
                case 'timeScareh':
                    this.dblistImg = '../../../static/images/index_bk_icon5.gif'
                    break
                case 'ailook':
                    this.dblistImg = '../../../static/images/index_bk_icon6.gif'
                    break
            }
        },
        // 跳转创作台
        gowriting() {
            this.$router.push('/page/writing')
        },
        // 跳转示例
        gosample() {
            this.$router.push({
                path: '/editor',
                query: {
                    id: 'Examples'
                }
            })
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
.home {
    padding-bottom: 100px;
}

.bg_box {
    background: $boxcolor;
}

.rowBox {
    width: $mWidth;
    position: relative;
    margin: 0 auto;
    padding-top: 100px;

    .t_c_xbt {
        font-size: 40px;
        font-weight: bold;
    }

    .bi {
        position: absolute;
        width: 534px;
        height: 546px;
        left: 0;
        bottom: 4rem;
        background: url('/static/images/b.png') no-repeat;
        background-size: 100%;
    }

    .gan {
        position: absolute;
        width: 534px;
        height: 546px;
        right: -50px;
        top: -60px;
        background: url('/static/images/g.png') no-repeat;
        background-size: 100%;
    }

    .start {
        background: $btnc;
        color: #ffffff;
        width: 10rem;
        font-size: 1.3rem;
        height: 3rem;
        border-radius: 1.5rem;
        cursor: pointer;
        position: relative;
        z-index: 2;
    }

    .Mtop {
        margin-top: 1rem;
    }

    .top50 {
        margin-top: 3rem;
    }

    .look {
        background: none;
        color: $btnc;
        width: 10rem;
        border-color: $btnc;
        font-size: 1.3rem;
        height: 3rem;
        border-radius: 1.5rem;
        margin-left: 2.1rem;
        cursor: pointer;
        position: relative;
        z-index: 2;
    }

    .banner_box1 {
        width: $mWidth;
        height: 25rem;
        margin-top: 7rem;
        position: relative;
        z-index: 2;
        overflow: hidden;
        padding-bottom: 50px;
    }
}

.my_top {
    font-size: 30px;
    font-weight: bold;
}

.mytabs {
    background: #f7f8fb;
    margin-top: 73px;

    >>>.el-tabs__item {
        font-size: 18px;
        padding: 0 50px;
    }
}

.databox {
    width: $mWidth;
    margin: 5rem auto;
    padding-bottom: 5rem;

    .databox-lists {
        background: url(../../../static/images/index_bk1_bg.png) no-repeat center center/100% 100%;
        width: 100%;
        height: 586px;
        text-align: center;

        img {
            width: 870px;
            height: 489px;
            box-shadow: 0px 0px 20px 9px #0b163730;
            ;
        }
    }
}

.titlelist {
    width: $mWidth;
    display: flex;
    margin: 0 auto;
    justify-content: center;
    margin-top: 10rem;

    .imglist {
        margin-right: 5rem;
        width: 500px;

        img {
            display: inline-block;
            width: 100%;
        }
    }

    .Rimglist {
        margin-left: 5rem;
        width: 500px;

        img {
            display: inline-block;
            width: 100%;
        }
    }

    .textlist {
        width: 500px;
        margin-top: 9rem;
        background: url(../../../static/images/index_bk_icony.png) no-repeat right bottom/30%;

        h2 {
            font-size: 30px;
            line-height: 35px;
        }

        .ptop {
            margin-top: 1.8rem;
            font-size: 1.1rem;
            line-height: 25px;
        }
    }

    .textlisttwo {
        margin-top: 12rem;
        background: url(../../../static/images/index_bk_iconz.png) no-repeat left 80%/30%;
    }

}
</style>



// WEBPACK FOOTER //
// src/pages/home/home.vue